var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8252 48.825C50.6618 48.825 57.8252 41.4377 57.8252 32.325C57.8252 23.2123 50.6618 15.825 41.8252 15.825C32.9886 15.825 25.8252 23.2123 25.8252 32.325C25.8252 41.4377 32.9886 48.825 41.8252 48.825Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8252 80.825C63.3643 80.825 80.8252 63.3641 80.8252 41.825C80.8252 20.2858 63.3643 2.82495 41.8252 2.82495C20.2861 2.82495 2.8252 20.2858 2.8252 41.825C2.8252 63.3641 20.2861 80.825 41.8252 80.825Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8252 69.825C17.6752 57.9462 28.6127 48.825 41.8377 48.825C55.0627 48.825 65.8752 57.8339 67.8252 69.6004",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.d2c074482718db92c7a5f6810a9c34f4.svg";
export { ForwardRef as ReactComponent };